import FormModel from './form-model.js'
import FormModelVersion from './form-model-version.js'
import FormTechnicalModel from './form-technical-model.js'
import FormTechnicalModelVersion from './form-technical-model-version.js'

/**
 * FormModel gets models from automotive (used in motos)
 */
export default FormModel
/**
 * FormModelVersion gets models from vehicle specs micro
 */
export {FormModelVersion}
/**
 * FormTechnicalModel gets models from vehicle specs micro
 */
export {FormTechnicalModel}

/**
 * FormTechnicalModelVersion gets models from vehicle specs micro
 */
export {FormTechnicalModelVersion}
